/**
 * Utility — 汎用ユーティリティ
 */
// biome-ignore lint/complexity/noStaticOnlyClass: utility class pattern intentional
export class Utility {
  /** debounce */
  static debounce<T extends (...args: unknown[]) => void>(fn: T, wait: number): T {
    let timer: ReturnType<typeof setTimeout> | null = null;
    return function (this: unknown, ...args: unknown[]) {
      if (timer !== null) clearTimeout(timer);
      timer = setTimeout(() => fn.apply(this, args), wait);
    } as T;
  }

  /** throttle */
  static throttle<T extends (...args: unknown[]) => void>(fn: T, wait: number): T {
    let lastTime = 0;
    return function (this: unknown, ...args: unknown[]) {
      const now = Date.now();
      if (now - lastTime >= wait) {
        lastTime = now;
        fn.apply(this, args);
      }
    } as T;
  }

  /** CSS カスタムプロパティ設定 */
  static setCssVar(
    name: string,
    value: string,
    target: HTMLElement = document.documentElement
  ): void {
    target.style.setProperty(`--${name}`, value);
  }

  /** ビューポート高さを CSS 変数で設定（モバイルアドレスバー対策） */
  static setViewportHeight(): void {
    const vh = window.innerHeight * 0.01;
    Utility.setCssVar('vh', `${vh}px`);
  }

  /** メディアクエリマッチ */
  static isSP(): boolean {
    return !window.matchMedia('(min-width: 768px)').matches;
  }

  static isPC(): boolean {
    return window.matchMedia('(min-width: 1024px)').matches;
  }

  /** 外部リンク判定 */
  static isExternalLink(href: string): boolean {
    try {
      const url = new URL(href, window.location.href);
      return url.hostname !== window.location.hostname;
    } catch {
      return false;
    }
  }

  /** tel リンク判定 */
  static isTelLink(href: string): boolean {
    return href.startsWith('tel:');
  }

  /** DOM Ready */
  static ready(fn: () => void): void {
    if (document.readyState !== 'loading') {
      fn();
    } else {
      document.addEventListener('DOMContentLoaded', fn, { once: true });
    }
  }
}
